module.exports = __webpack_public_path__ + "static/img/200112.66495700.png";